import {CONFIG_DEV} from './ConfigDev';
import {CONFIG_AKM} from './ConfigAkm';
import {CONF_API_BE} from './ConfigApiBe';
export const CONFIG = CONFIG_DEV;
export const URL_AKM = CONFIG_AKM;
export const CONFIG_API_BE = CONF_API_BE;